@let homeCrumb = home();
@let items = trail();
@if (homeCrumb && items.length) {
  <div [class.absolute]="isOverlay()" [class.z-10]="isOverlay()" class="box-border w-full p-5 pt-8 desk:pt-5">
    <nav
      class="inline-flex max-w-full items-center gap-x-1.5 overflow-hidden rounded-full bg-white/80 px-4 py-1.5 text-[9px] shadow-md backdrop-blur-sm desk:text-sm">
      <!-- Fixed: Home + first chevron -->
      <a [routerLink]="homeCrumb.url" class="shrink-0 text-verdigris">
        <svg class="size-3" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
          <path
            d="M2.25 12l8.954-8.955a1.126 1.126 0 011.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </a>
      <span class="shrink-0 text-gray">
        <svg class="size-2" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path d="M8.25 4.5l7.5 7.5-7.5 7.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </span>
      <!-- Scrollable: items -->
      <div class="no-scrollbar flex min-w-0 flex-1 items-center gap-x-1.5 overflow-x-auto">
        @for (item of items; track item.url; let isFirst = $first; let isLast = $last) {
          @if (!isFirst) {
            <span class="shrink-0 text-gray">
              <svg class="size-2" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path d="M8.25 4.5l7.5 7.5-7.5 7.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
          }
          @if (item.url && !isLast) {
            <a [routerLink]="item.url" class="shrink-0 text-nowrap uppercase tracking-wide text-verdigris">{{
              item.title
            }}</a>
          } @else {
            <span class="shrink-0 text-nowrap font-semibold uppercase tracking-wide text-verdigris">{{
              item.title
            }}</span>
          }
        }
      </div>
    </nav>
  </div>
}
